// The places stream's planted defects (gate C4), each switched beside what it breaks and joined into `__rpg.faults`
// through the fault group; `?faults=` names them at boot.
//   places-no-profile   the view never asks the camera for the interior profile on entry (src/places/view.ts): the
//                       walk-in check must go red;
//   places-no-warp      a transition door fades but never moves the player (@rpg/world's Interiors.faults.noWarp): the
//                       transition check must go red;
//   places-water-box    water queries answer by each volume's box, ignoring its outline (@rpg/collision's
//                       faults.waterBoxOnly): the water check (a bank inside the stream's box) must go red;
//   places-kit-unseeded the kit draws variation from Math.random (@rpg/meshkit's KIT_FAULTS.unseeded): the same-seed
//                       kit hash must go red.
import { KIT_FAULTS } from "@rpg/meshkit";
import type { FaultGroup } from "../faults";

export const PLACES_FAULT_NAMES = ["places-no-profile", "places-no-warp", "places-water-box", "places-kit-unseeded"] as const;
export type PlacesFaultName = (typeof PLACES_FAULT_NAMES)[number];

/** The record (the live objects read it each step or frame). */
export const PLACES_FAULTS: Record<PlacesFaultName, boolean> = { "places-no-profile": false, "places-no-warp": false, "places-water-box": false, "places-kit-unseeded": false };

/** The places fault group; reads `?faults=` for its own names on creation. */
export function placesFaultGroup(search = typeof location !== "undefined" ? location.search : ""): FaultGroup {
  const on = (new URLSearchParams(search).get("faults") ?? "").split(",");
  for (const n of PLACES_FAULT_NAMES) PLACES_FAULTS[n] = on.includes(n);
  KIT_FAULTS.unseeded = PLACES_FAULTS["places-kit-unseeded"];
  return {
    names: PLACES_FAULT_NAMES,
    get: (n) => PLACES_FAULTS[n as PlacesFaultName] === true,
    set: (n, v) => {
      PLACES_FAULTS[n as PlacesFaultName] = v;
      if (n === "places-kit-unseeded") KIT_FAULTS.unseeded = v;
    },
  };
}
